import {
  BMBadgeTag,
  BMPrimitives,
  BMText,
  useBMTheme,
} from "@traveloka/district-bloom";
import { escapeRegExp } from "lodash";
import { ReactElement, useCallback, useEffect, useState } from "react";
import { Pressable, StyleSheet } from "react-native";
import BMView from "../../../../components/View/BMView";
import { useMobileContentResource } from "../../../../core/resource/MobileResourceProvider";
import { useHotelAutocomplete } from "../../../../providers/api/HotelAutocompleteContext";
import { HotelSearchResponseItem } from "./types";

type Props = {
  item: HotelSearchResponseItem;
  query: string;
  onCloseDialog: () => void;
};

export default function SearchResultItem(props: Props) {
  const { item, query, onCloseDialog } = props;
  const [highlightedName, setHighlightedName] =
    useState<(string | ReactElement)[]>();
  const bmTheme = useBMTheme();
  const { handleSelectSearchItem } = useHotelAutocomplete();
  const { CorporateHotelSearchForm } = useMobileContentResource();

  useEffect(() => {
    const regex = new RegExp(`(${escapeRegExp(query)})`, "gi");

    setHighlightedName(
      item.name.split(regex).map((part, index) =>
        regex.test(part) ? (
          <BMText key={index} variant="uiLarge" ink="BMUiButtonInkSecondary">
            {part}
          </BMText>
        ) : (
          part
        )
      )
    );
  }, [item, query]);

  const getBadgeText = useCallback(
    (type: string) => {
      switch (type) {
        case "HOTEL":
          return CorporateHotelSearchForm.destinationTypeHotel;
        case "LANDMARK":
          return CorporateHotelSearchForm.destinationTypeLandmark;
        case "REGION":
        default:
          return CorporateHotelSearchForm.destinationTypeRegion;
      }
    },
    [CorporateHotelSearchForm]
  );

  function handleSelectItem() {
    handleSelectSearchItem(item);
    onCloseDialog();
  }
  return (
    <Pressable onPress={handleSelectItem}>
      <BMView
        row
        justify="between"
        style={[
          styles.container,
          {
            borderBottomColor: bmTheme.BMComponents.BMStyleTextInkPrimaryInvert,
          },
        ]}
      >
        <BMView>
          <BMText
            numberOfLines={1}
            ellipsizeMode="tail"
            variant="uiLarge"
            ink="BMStyleTextInkPrimary"
            style={styles.text}
          >
            {highlightedName}
          </BMText>
          <BMText
            numberOfLines={1}
            ellipsizeMode="tail"
            variant="uiNormalLi"
            ink="BMStyleTextInkSecondary"
            style={styles.text}
          >
            {item.location}
          </BMText>
        </BMView>
        <BMView
          style={{
            width: 80,
          }}
          align="center"
          spacing="xs"
        >
          <BMView>
            <BMBadgeTag type="BLUE" label={getBadgeText(item.type)} />
          </BMView>
          {!!Number(item.numOfHotels) && (
            <BMText>{item.numOfHotels} hotels</BMText>
          )}
        </BMView>
      </BMView>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  container: {
    borderBottomWidth: BMPrimitives.BMStroke.sm,
    paddingBottom: BMPrimitives.BMSize.sm,
  },
  text: {
    width: 247,
    overflow: "hidden",
  },
});
